import React from "react";
import Left from "../Design&DevApproch/Left.jsx";
import line from "../Design&DevApproch/Dev&DesignImages/line.png";

const DesignDev = () => {
  return (
    <section className="mt-20 sm:mt-28 lg:mt-40 border-t border-b border-gray-300 bg-[#f7f7fa] py-16 sm:py-20 lg:py-24">
      {/* === Heading === */}
      <div className="text-center px-4 sm:px-6 mb-10 sm:mb-14 lg:mb-20">
        <img
          src={line}
          alt="line"
          className="mx-auto pb-4 sm:pb-5 w-24 sm:w-32"
        />
        <h1 className="text-2xl sm:text-3xl lg:text-4xl leading-8 sm:leading-9 lg:leading-[55px] text-[#1a202c] font-medium">
          Our design and
          <br />
          <span className="font-bold">development approach</span>
        </h1>
      </div>

      {/* === Content Section === */}
      <div className="px-4 sm:px-6 lg:px-[80px]">
        <Left />
      </div>
    </section>
  );
};

export default DesignDev;
